import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams } from 'react-router-dom';
import Layout from "../layout"
import { loadDocs, selectDocsProject, selectDocsProjectType } from "../../redux/modules/docs"
import Files from './files'

const DocsFiles = () => {    
    const dispatch = useDispatch();
    let { detail, type, files } = useParams();
    const auth = useSelector(state => state.auth);
    const docs = useSelector(state => state.docs);
    const project = useSelector(state => selectDocsProject(state, detail));
    const docsfiles = useSelector(state => selectDocsProjectType(state, detail, type, files));

    useEffect(() => {
        document.title = 'Документы | Личный кабинет Брокера THE FIVE';
        if(!docs.loaded) {
            dispatch(
                loadDocs({
                    cmd: 'docs',
                    _debug_token: auth.token
                })
            )
        }
    }, [])

    console.log(project)
    
    return (
        <Layout>            
            {project && (<>
                <div class="breadcrumbs">
                    <Link to="/docs">проекты</Link>
                    <svg xmlns="http://www.w3.org/2000/svg" width="6" height="16" viewBox="0 0 6 16" fill="none">
                        <path d="M4.62354 1.23828L1.00007 14.7612" stroke="#7B7168" stroke-linecap="square"/>
                    </svg>
                    <Link to={`/docs/${project[0].link}`}>{project[0].name}</Link>
                </div>
                <div className="title">{docsfiles[0].name}</div>
                {docsfiles[0].docs.length && <Files data={docsfiles[0].docs} />}
            </>)}            
        </Layout>
    )
}

export default DocsFiles